/**
 * Distillery card component for mobile view
 */

import { Button } from '../common';
import './DistilleryCard.css';

/**
 * Card displaying distillery information
 * @param {Object} props - Component props
 * @param {Object} props.distillery - Distillery data
 * @param {Function} props.onClick - Click handler
 * @param {Function} props.onEdit - Edit handler
 * @param {Function} props.onDelete - Delete handler
 * @returns {React.ReactElement} Card element
 */
export default function DistilleryCard({
  distillery,
  onClick,
  onEdit,
  onDelete,
  onViewBottles
}) {
  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete();
  };

  const handleViewBottles = (e) => {
    e.stopPropagation();
    onViewBottles();
  };

  return (
    <div className="distillery-card" onClick={onClick}>
      <div className="distillery-card__header">
        <h3 className="distillery-card__name">{distillery.distillery_name}</h3>
        <span className="distillery-card__country">{distillery.country}</span>
      </div>

      <div className="distillery-card__details">
        {(distillery.city || distillery.state_region) && (
          <p className="distillery-card__location">
            {[distillery.city, distillery.state_region].filter(Boolean).join(', ')}
          </p>
        )}
        {distillery.year_founded && (
          <p className="distillery-card__founded">
            Founded: {distillery.year_founded}
          </p>
        )}
      </div>

      <div className="distillery-card__actions">
        {distillery.website_url && (
          <a
            className="btn btn--sm btn--ghost"
            href={distillery.website_url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          >
            Website
          </a>
        )}
        <Button size="sm" variant="ghost" onClick={handleViewBottles}>
          Bottles
        </Button>
        <Button size="sm" variant="ghost" onClick={handleEdit}>
          Edit
        </Button>
        <Button size="sm" variant="danger" onClick={handleDelete}>
          Delete
        </Button>
      </div>
    </div>
  );
}
